import React, { FC } from "react";
import { Styled } from "./Download.styled";

const Download: FC = () => {
  return <Styled.DownloadLogo />;
};

export default Download;
